module.exports = __webpack_public_path__ + "img/1-ajouter-partenaire-mobile.7a436c8a.png";